/**
 * Registro do service worker base (PWA — ADR-010).
 * Registra apenas em produção para não interferir no HMR do Vite em DEV.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  if (!import.meta.env.PROD) {
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Falha ao registrar o service worker:', err);
    });
  });
}
